exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#333",
	"menuActiveText": "#3469fb",
	"subMenuActiveText": "#3469fb",
	"menuBg": "#f0f2f5",
	"menuHover": "#e0e4e8",
	"subMenuBg": "#fff",
	"subMenuHover": "#e0e4e8",
	"sideBarWidth": "230px"
};